import { render, staticRenderFns } from "./CarriersSorter.vue?vue&type=template&id=105eb981&scoped=true"
import script from "./CarriersSorter.vue?vue&type=script&lang=js"
export * from "./CarriersSorter.vue?vue&type=script&lang=js"
import style0 from "./CarriersSorter.vue?vue&type=style&index=0&id=105eb981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105eb981",
  null
  
)

export default component.exports